const routers = [
    {
        path: '/designer',
        name: 'designer',
        meta: {
            exp: '设计师模块',
            requireAuth: false
        },
        component: () => import('@/views/designer/index.vue'),
        redirect: '/designer/designer_list',
        children: [
            {
                path: '/designer/designer_list',
                name: 'designer_list',
                meta: {
                    exp: "毕业生列表",
                    requireAuth: false
                },
                component: () => import('@/views/designer/designer_list/index.vue'),
            },
            {
                path: '/designer/student_detail',
                name: 'student_detail',
                meta: {
                    exp: "毕业生个人主页",
                    requireAuth: false
                },
                redirect: '/designer/student_opus',
                component: () => import('@/views/designer/student_detail/index.vue'),
                children: [
                    {
                        path: '/designer/student_opus',
                        name: 'student_opus',
                        meta: {
                            exp: "毕业生作品",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/student_detail/student_opus/index.vue')
                    },
                    {
                        path: '/designer/student_mien',
                        name: 'student_mien',
                        meta: {
                            exp: "'毕业生风采",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/student_detail/student_mien/index.vue')

                    },
                    {
                        path: '/designer/student_praise',
                        name: 'student_praise',
                        meta: {
                            exp: "毕业生赞过",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/student_detail/student_praise/index.vue')

                    },
                ],
            },
            {
                path: '/designer/teacher_detail',
                name: 'teacher_detail',
                meta: {
                    exp: "教师个人主页",
                    requireAuth: false
                },
                redirect: '/designer/teacher_opus',
                component: () => import('@/views/designer/teacher_detail/index.vue'),
                children: [
                    {
                        path: '/designer/teacher_opus',
                        name: 'teacher_opus',
                        meta: {
                            exp: "教师作品",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/teacher_detail/teacher_opus/index.vue')
                    },
                    {
                        path: '/designer/teacher_mien',
                        name: 'teacher_mien',
                        meta: {
                            exp: "'教师风采",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/teacher_detail/teacher_mien/index.vue')

                    },
                    {
                        path: '/designer/teacher_praise',
                        name: 'teacher_praise',
                        meta: {
                            exp: "教师赞过",
                            requireAuth: false
                        },
                        component: () => import('@/views/designer/teacher_detail/teacher_praise/index.vue')

                    },
                ],
            },
        ]
    }
]
export default routers
